import { Component } from '@angular/core';

@Component({
  selector: 'app-permission-role-user-search',
  templateUrl: './permission-search.component.html',
  styleUrls: ['./permission-search.component.css']
})
export class PermissionSearchComponent {

}
